import { Button } from "components/shadcn/button";
import Image from "next/image";
import { useRouter } from "next/router";
import { translate } from "components/common/Translate/Translate";
import { getQueryParam } from "@/utils/getQueryParam";
import useSubscription, { RedirectActions } from "@/modules/Dashboard/Pricing/useSubscription";

const GoogleAuthButton = () => {
    const { setDashboardRedirectAction } = useSubscription();
    const router = useRouter();
    return (
        <div>
            <Button
                variant="outline"
                className="w-full flex items-center justify-center space-x-2"
                onClick={() => {
                    if (router.locale) {
                        localStorage.setItem("locale", router.locale);
                    }
                    const redirectUrl = getQueryParam("redirect");
                    if (redirectUrl) {
                        setDashboardRedirectAction(
                            JSON.stringify({
                                type: RedirectActions.redirect,
                                url: redirectUrl,
                            }),
                        );
                    }
                    router.push(`${process.env.NEXT_PUBLIC_ACCOUNT_SERVER_URL}/auth/google`);
                }}
            >
                <Image
                    src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                    alt="Google logo"
                    className="w-5 h-5"
                    width={16}
                    height={16}
                />
                <span>{translate("continue-with-google")}</span>
            </Button>
        </div>
    );
};

export default GoogleAuthButton;
